export const eventStatus = [
  {
    header: "Waiting for",
  },
  {
    label: "Waiting for operator",
    value: "waiting_for_operator",

    //  Inväntar operatör
  },
  {
    label: "Waiting for customer details",
    value: "waiting_for_customer_details",
    // Inväntar bankuppgifter
  },
  {
    label: "Waiting for tickets",
    value: "waiting_for_tickets",
    // Inväntar biljett(er)
  },
  {
    label: "Waiting for document",
    value: "waiting_for_document",
    // Inväntar dokument
  },
  {
    label: "Waiting for silverrail",
    value: "waiting_for_silverrail",
    // Inväntar svar från SilverRail
  },
  { divider: true },
  { header: "Events" },
  {
    label: "Tickets are returned",
    value: "document_returned",
    // Biljett(er) kom i retur
  },
  {
    label: "Tickets are cancelled",
    value: "tickets_cancelled",
    // Biljett(er) avbeställda
  },
  {
    label: "Documents Arrived",
    value: "documents_arrived",
  },
  { divider: true },
  { header: "Refunding" },
  {
    label: "Refund 'Felexpedierad'",
    value: "refund_linkonline_fe",
    // Felexpedierad i Linkonline
  },
  {
    label: "Refunding in Linkonline",
    value: "refund_linkonline_at",
    // Krediterad i Linkonline
  },
  {
    label: "Refund 'annan orsak'",
    value: "refund_linkonline_ao",
    // Krediterad annan orsak i Linkonline
  },
  {
    label: "Refund 'särskilda fall'",
    value: "refund_linkonline_sf",
    // Krediterad särskilda fall i Linkonline
  },
  {
    label: "Refund with Klarna",
    value: "refund_klarna",
    // Krediterad i Klarna
  },
  {
    label: "Refund with Fortnox",
    value: "refund_fortnox",
    // Krediterad i Fortnox
  },
  {
    label: "Refund with voucher",
    value: "refund_giftcard",
    // Återbetald via tillgodokort
  },
  {
    label: "Refund taxi",
    value: "refund_taxi",
  },
  {
    label: "Checked by TP",
    value: "checked_by_tp",
  },
  {
    label: "Authorized by Tenant",
    value: "authorized_by_tenant",
  },
  { divider: true },
  { header: "Others" },
  {
    label: "New comments",
    value: "comment",
    // Ny kommentar
  },
  {
    label: "Inquiry Customer Updated",
    value: "INQUIRY_CUSTOMER_UPDATED",
  },
];
